import { Locale } from "./iLocale";

export default {
    lang: 'zh_CN',
    Popconfirm: {
        'ok': '确定',
        'cancel': '取消'
    },
    Table: {
        'resetSettings': '还原设置',
        'include': '包含',
        'exclusive': '不包含',
        'equal': '等于',
        'unequal': '不等于',
        'begin': '以开始',
        'end': '以结尾',
        'greaterThan': '大于',
        'greatThanEqualTo': '大于等于',
        'lessThan': '小于',
        'lessThanEqualTo': '小于等于',
        'beEqualTo': '等于',
        'notEqualTo': '不等于',
        "noData": '暂无数据',
    },
    Clipboard: {
        'copy': '复制',
        'cut': '剪切',
        'copyReady': '已复制',
        'cutReady': '已剪切',
        'copyToClipboard': '复制到剪切板',
        'close': '关闭',
    },
    Pagination: {
        'total': '共',
        'items': '条',
        'show': '显示',
        'goto': '跳至',
        'page': '页',
        'ok': '确定'
    },
    Grid: {
        'lang': 'zh-cn',
        'fixTitle': '锁定',
        'noFixTitle': '解锁',
        'hideTitle': '隐藏',
        'rowFilter': '行过滤',
        'openRowFilter': '打开行过滤',
        'closeRowFilter': '关闭行过滤',
    },
    SearchPanel: {
        'title': '默认筛选',
        'resetName': '清空',
        'searchName': '查询',
        'down': '展开',
        'up': '收起',
    },
    InputNumber: {
        'msgMax': '值不能大于最大值',
        'msgMin': '值不能小于最小值'
    },
    Modal: {
        'ok': '确定',
        'gotit': '知道了',
        'cancel': '取消',
    },
    Loading: {
        'loading': '加载中...',
    },
    Upload: {
        'remove': '移除文件',
        'down': '下载文件',
        'fileLoading': '文件上传中',
    }
} as Locale
